<template>
  <v-dialog v-model="showModal" max-width="750px" persistent>
    <v-card class="pa-4">
      <v-card-title>
        <h2>
        Refinanciamientos
        </h2>
      </v-card-title>
      <v-card-text>
        <v-card flat>
          <vue-perfect-scrollbar>
            <v-card-text class="customer-dues pa-0">
              <v-container grid-list-lg fluid>
                <v-layout row wrap>
                  <v-data-table
                    :headers="headers"
                    hide-actions
                    class="w-100"
                    no-data-text="No se encontraron datos"
                    :items="rows"
                    :pagination.sync="sorting">
                    <template slot="headers" slot-scope="props">
                      <th v-for="(header, index) in props.headers" :key="`header-${index}`" class="text-xs-center">
                        <v-icon class="k-orange-linear-text mr-2">{{ header.icon }}</v-icon>
                        <span>
                          {{ header.text }}
                        </span>
                      </th>
                    </template>
                    <template slot="items" slot-scope="props">
                      <tr>
                        <td>
                          {{ props.item.name }}
                        </td>
                        <td>
                          {{ props.item.local_date | formatDate }}
                        </td>
                        <td>
                          {{ $store.getters.refinancingStatus(props.item.status_id).name }}
                        </td>
                        <td class="text-xs-center">
                          <v-btn flat icon @click="props.expanded = !props.expanded">
                            <v-icon small>fa-chevron-down</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </template>
                    <template slot="expand" slot-scope="props" colspan="4">
                      <vue-perfect-scrollbar class="sub-table" :settings="{ suppressScrollX: true }">
                        <template
                          v-if="$store.state.dialer.callCenterStatus !== 0
                            && $store.state.dialer.callType !== 'manual'
                            && $store.state.dialer.callType !== 'manual_v2'
                            && (
                              !Object.keys(($store.state.dialer.currentRecording || {})).length
                              || $store.state.dialer.currentRecording.refinancing_id === props.item.id
                            )"
                          >
                          <v-layout row wrap>
                            <v-flex class="text-xs-center">
                              <template v-if="loadingRecording">
                                <div class="my-3">
                                  <v-icon large class="mr-3">
                                    fas fa-sync-alt fa-spin
                                  </v-icon>
                                  <span>
                                    Procesando...
                                  </span>
                                </div>
                              </template>
                              <template v-else-if="!$store.state.dialer.isRecording">
                                <v-btn color="k-blue-linear" medium fab @click="startRecording(props.item.id)">
                                  <v-icon color="white">
                                    fas fa-microphone
                                  </v-icon>
                                </v-btn>
                                <span>
                                  Iniciar grabación
                                </span>
                              </template>
                              <template v-else>
                                <v-btn color="red" medium fab @click="stopRecording">
                                  <v-icon color="white">
                                    fas fa-stop
                                  </v-icon>
                                </v-btn>
                                <span>
                                  Detener grabación
                                </span>
                              </template>
                            </v-flex>
                          </v-layout>
                          <v-divider></v-divider>
                        </template>
                        <v-layout row wrap style="height: 150px;">
                          <v-flex xs12>
                            <v-radio-group v-model="props.item.current_recording" :hide-details="true" @change="checkRecording($event, props.item.id)" class="pt-0">
                              <table class="sub-table" :key="tableKey">
                                <tbody>
                                  <template v-if="(props.item.recordings || []).length">
                                    <tr v-for="(item, i) in sortRecordings(props.item.recordings || [])" :key="`recording-${i}`">
                                      <td>
                                        <v-radio :value="item.location" :disabled="$store.state.dialer.isRecording || loadingRecording"/>
                                      </td>
                                      <td>
                                        {{ item.created_at | formatDate }}
                                      </td>
                                      <td>
                                        <audio controls>
                                          <source :src="getUrl(item.location)" type="audio/x-wav">
                                          Your browser does not support the audio element.
                                        </audio>
                                      </td>
                                      <td class="text-xs-left">
                                        <v-btn flat icon @click="deleteRecording(props.item.id, item.location)">
                                          <v-icon small>
                                            fas fa-trash-alt
                                          </v-icon>
                                        </v-btn>
                                      </td>
                                    </tr>
                                  </template>
                                  <tr v-else>
                                    <td class="text-xs-center">
                                      No hay grabaciones que mostrar
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </v-radio-group>
                          </v-flex>
                        </v-layout>
                      </vue-perfect-scrollbar>
                    </template>
                  </v-data-table>
                </v-layout>
              </v-container>
            </v-card-text>
          </vue-perfect-scrollbar>
        </v-card>        
      </v-card-text>
      <v-card-actions>
        <v-btn color="black" class="ml-auto" flat :disabled="loadingRecording" @click.stop="$emit('close')">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import moment from 'moment';
import _ from 'lodash';
import EventBus from '@/event-bus';

const uuidv4 = require('uuid/v4');

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    customer: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    VuePerfectScrollbar,
  },
  data() {
    return {
      showModal: false,
      headers: [
        {
          text: 'Nombre',
          icon: 'fa-clipboard-list',
        },
        {
          text: 'Fecha',
          icon: 'fa-calendar-alt',
        },
        {
          text: 'Estatus',
          icon: 'fa-file-invoice',
        },
        {
          text: 'Grabaciones',
          icon: 'fa-microphone',
        },
      ],
      sorting: {
        sortBy: 'local_date',
        descending: true,
      },
      rows: [],
      tableKey: uuidv4(),
      interval: 0,
      loadingRecording: false,
    };
  },
  destroyed() {
    clearInterval(this.interval);
  },
  filters: {
    formatDate(date) {
      return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY');
    },
  },
  methods: {
    sortRecordings(recordings) {
      return _.orderBy(recordings, (a, b) => a.created_at - ((b || {}).created_at || 0), 'desc');
    },
    getUrl(key) {
      const [tmp] = window.location.hostname.split('.');
      let env;
      if (tmp.includes('-dev')) {
        env = 'dev';
      } else {
        env = 'prod';
      }
      return `https://colektia-refinancing-recordings-${env}.s3.amazonaws.com/${key}.mp3`;
    },
    startRecording(id) {
      const recordingKey = uuidv4();

      this.loadingRecording = false;
      this.$store.commit('dialer/SET_IS_RECORDING', true);
      this.$store.commit('dialer/SET_CURRENT_RECORDING', {
        call_id: this.$store.state.dialer.notification.call_id,
        refinancing_id: id,
        key: recordingKey,
        created_at: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
      });

      this.axios.post('asterisk/start_recording', {
        refinancing_id: id,
        recording_filename: recordingKey,
        notification_id: this.$store.state.dialer.notification.id,
      }).catch(() => {
        this.$store.commit('dialer/SET_IS_RECORDING', true);
        this.$store.commit('dialer/SET_CURRENT_RECORDING', {});
        this.loadingRecording = false;
        EventBus.$emit('error', 'Ha ocurrido un error, intentar nuevamente');
      });
    },
    stopRecording() {
      this.$store.commit('dialer/SET_IS_RECORDING', false);
      this.loadingRecording = true;
      this.axios.post('extensions/hangup_recording')
        .then(() => {
          this.interval = setTimeout(() => {
            const index = this.rows.findIndex(item => (
              item.id === this.$store.state.dialer.currentRecording.refinancing_id
            ));
            if (index !== -1) {
              const recordings = this.rows[index].recordings || [];
              recordings.push(this.$store.state.dialer.currentRecording);
              this.$set(this.rows, index, {
                ...this.rows[index],
                current_recording: this.$store.state.dialer.currentRecording.key,
                recordings,
              });
              this.$store.commit('dialer/SET_CURRENT_RECORDING', {});
            }
            this.$store.commit('dialer/SET_CURRENT_RECORDING', {});
            this.loadingRecording = false;
            this.tableKey = uuidv4();
          }, 10000);
        })
        .catch(() => {});
    },
    checkRecording(event, id) {
      this.axios.patch(`/customers_refinancing/${id}`, {
        current_recording: event,
      })
        .catch(() => {});
    },
    deleteRecording(id, key) {
      const index = this.rows.findIndex(item => item.id === id);
      if (index !== -1) {
        const refinancing = {
          ...this.rows[index],
        };
        const recordings = refinancing.recordings || [];
        const recordingIndex = recordings.findIndex(item => item.location === key);
        if (recordingIndex !== -1) {
          recordings.splice(recordingIndex, 1);
        }
        refinancing.recordings = recordings || [];
        if (recordings.length && refinancing.current_recording === key) {
          refinancing.current_recording = this.sortRecordings(recordings)[0].location;
        } else if (!recordings.length) {
          refinancing.current_recording = null;
        }
        this.axios.delete(`/customers_refinancing/${id}/recordings/${key}`)
          .then(() => {
            this.$set(this.rows, index, refinancing);
            this.tableKey = uuidv4();
          })
          .catch(() => {});
      }
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.axios.get(`/customers/${this.customer.id}/refinancings`)
          .then((response) => {
            this.loadingRecording = false;
            this.rows = response.data;
            this.showModal = true;
          })
          .catch(() => {
            // SHOW ERROR
            this.$emit('close');
          });
      } else {
        this.showModal = false;
      }
    },
  },
};
</script>

<style scoped>
  .customer-dues {
    height: 392px;
  }
  .customer-dues >>> .datatable.table {
    table-layout: fixed;
  }
  .customer-dues >>> .datatable.table td {
    padding-top: 6px !important;
    padding-bottom: 6px !important; 
    padding-right: 0px !important;
    word-break: break-all;
    white-space: normal !important;
  }
  .customer-dues >>> table.table tbody tr:first-child {
    border-top: 1px solid rgba(0,0,0,.12) !important;
  }
  .customer-dues >>> table.table tbody td {
    text-align: center;
  }
  .customer-dues >>> table.table tbody tr:not(:last-child):not(.datatable__expand-row) {
    border-bottom: 1px solid rgba(0,0,0,.12) !important;
  }
  .customer-dues >>> table.table tbody tr.datatable__expand-row .datatable__expand-col {
    padding-left: 0 !important;
  }
  .sub-table {
    width: 100%;
  }
  .sub-table th {
    text-align: left;
  }
  .sub-table td {
    padding: 16px !important;
  }
  .sub-table td ul {
    padding: 0;
    list-style: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/customer/RefinancingDialog.vue